import type { Locale } from '@porotutu/i18n'
import { ExportMenu } from '@porotutu/react/components/ExportMenu/ExportMenu'
import { EXPORT_SCOPES } from '../../vocabulary'
import { exportHref, type ManagedUserListQuery } from '../queries'

export type UsersExportProps = { query: ManagedUserListQuery; locale: Locale }

export function UsersExport({ query, locale }: UsersExportProps) {
  return (
    <ExportMenu
      scope="adm.users.export"
      scopes={EXPORT_SCOPES}
      href={(scope, format) => exportHref(query, scope, format, locale)}
    />
  )
}
